// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"social-module--socialIcon--1mCEk","iconsContainer":"social-module--iconsContainer--2XJWG"};